const locale = {
  COMPANY_STATISTICS: 'Analytics dashboard',
  COMPANY_STATISTICS_DESCRIPTION: 'Monitor metrics, check reports and performance',

  DOCUMENT_CAPTURE: 'Document capture',
  CLEAN_DOCUMENT_CAPTURE: 'Clean document capture',
  BARCODE_CAPTURE: 'Barcode capture',
  CREDIT_CARD_CAPTURE: 'Credit card capture',
  RFID_DOCUMENT_CAPTURE: 'Rfid document capture',
  SPECIFIC_DOCUMENT_CAPTURE: 'Specific document capture',
  SELFIE_CAPTURE: 'Selfie capture',
  FACE_CAPTURE: 'Face capture',
  PASSIVE_FACE_MATCH: 'Face match',
  FACE_LIVENESS: 'Liveness',
  SIGNATURE: 'Signature',
  OTP_VERIFICATION: 'Otp verification',
  UTILITY_BILL: 'Utility bill',
  DIIA: 'Diia',
  PASSIVE_LIVENESS: 'Liveness',

  // STATISTICS DASHBOARD
  STATS_PRESET_TODAY: 'Today',
  STATS_PRESET_7_DAYS: '7 days',
  STATS_PRESET_30_DAYS: '30 days',
  ALL_WORKFLOWS: 'All workflows',
  STATS_WORKFLOWS_LOADING: 'Loading workflows…',
  STATS_RANGE_ORDER: 'The end date is before the start date. Choose another range.',
  STATS_RANGE_TOO_LONG: 'The range is too long. Choose at most {{max}} days.',
  STATS_ERROR_BUSY: 'The service is busy. Other blocks are not affected.',
  STATS_ERROR_INVALID: "This period can't be shown: {{field}}",
  STATS_ERROR_INVALID_PERIOD: "This period can't be shown",
  STATS_ERROR_GENERIC: "Couldn't load this block",
  STATS_RETRY: 'Retry',
  STATS_EMPTY: 'No data in this period',
  STATS_ERROR_FORBIDDEN: "You don't have access to this block",
  STATS_EMPTY_FUNNEL: 'No sessions in this period',
  STATS_EMPTY_SERVICES: 'Nothing was charged in this period',
  STATS_EMPTY_DECISIONS: 'No decisions in this period',
  STATS_EMPTY_REBUILDING: 'History is still being rebuilt',
  STATS_EMPTY_REBUILDING_HINT: 'Check back once the rebuild finishes',
  STATS_EMPTY_HINT_PERIOD: 'Try a longer period or change the filters',
  STATS_FIELD_period: 'period',
  STATS_FIELD_tz: 'time zone',
  STATS_FIELD_appKey: 'workflow',
  STATS_NOTE_REBUILDING: 'History is still being rebuilt, so some numbers may be incomplete.',
  STATS_NOTE_APPROXIMATE: 'Numbers before {{since}} are approximate.',
  STATS_KPI_SESSIONS_STARTED: 'Sessions started',
  STATS_KPI_SESSIONS_COMPLETED: 'Sessions completed',
  STATS_KPI_COMPLETION_RATE: 'Completion rate',
  STATS_KPI_APPLICANTS_CREATED: 'New applicants',
  STATS_KPI_APPROVED: 'Approved',
  STATS_KPI_REJECTED: 'Rejected',
  STATS_NOW_AWAITING_REVIEW: 'Awaiting review',
  STATS_NOW_ON_HOLD: 'On hold',
  STATS_NOW_REVIEWED_TODAY: 'Reviewed today',
  STATS_NOW_MEDIAN: 'median {{median}}',
  STATS_NOW_TODAY_ZONE: 'Today in {{zone}}',
  STATS_TREND_PP: 'pp',
  STATS_TREND_UP: 'Up',
  STATS_TREND_DOWN: 'Down',
  STATS_TREND_FLAT: 'No change',
  STATS_TREND_VS_PREV: 'vs prev.',
  STATS_TILE_TOOLTIP:
    'This period ({{from}} – {{to}}): {{current}} · Previous ({{previousFrom}} – {{previousTo}}): {{previous}}',
  STATS_COUNT: 'Count',
  STATS_SHARE: 'Share',
  STATS_TOTAL: 'Total',
  STATS_OTHER: 'Other',
  STATS_NO_CHART_DATA: 'Nothing to chart in this period',
  STATS_FUNNEL_NO_PLATFORMS: 'No sessions by platform in this period',
  STATS_FUNNEL_NO_FAILURES: 'No failed sessions in this period',
  STATS_GEO_NO_COUNTRIES: 'No sessions with a known country',
  STATS_REVIEWERS_NO_ACTIVITY: 'No reviewer activity in this period',
  STATS_FUNNEL_TITLE: 'Verification funnel',
  STATS_FUNNEL_STARTED: 'Started',
  STATS_FUNNEL_COMPLETED: 'Completed',
  STATS_FUNNEL_FAILED: 'Failed',
  STATS_FUNNEL_ABANDONED: 'Abandoned',
  STATS_FUNNEL_BY_PLATFORM: 'By platform',
  STATS_FUNNEL_PLATFORM: 'Platform',
  STATS_FUNNEL_FAILURE_REASONS: 'Top failure reasons',
  STATS_FUNNEL_REASON: 'Reason',
  STATS_PLATFORM_WEB: 'Web',
  STATS_PLATFORM_IOS: 'iOS',
  STATS_PLATFORM_ANDROID: 'Android',
  STATS_DECISIONS_TITLE: 'Decisions',
  STATS_DECIDED_BY_ALL: 'All',
  STATS_DECIDED_BY_REVIEWER: 'Reviewer',
  STATS_DECIDED_BY_SYSTEM: 'System',
  STATS_DECIDED_BY_UNATTRIBUTED: 'Unattributed',
  STATS_DECIDED_BY_TITLE: 'Who decided',
  STATS_DECIDED_BY_NONE: 'No decider recorded in this period',
  STATS_DECISIONS_NO_WARNINGS: 'No warnings in this period',
  STATS_OUTCOME: 'Outcome',
  STATS_OUTCOME_APPROVED: 'Approved',
  STATS_OUTCOME_REJECTED: 'Rejected',
  STATS_OUTCOME_INCOMPLETE: 'Resubmission',
  STATS_OUTCOME_ON_HOLD: 'On hold',
  STATS_WARNINGS_TITLE: 'Warnings by type',
  STATS_WARNING_TYPE: 'Warning',
  STATS_WARNINGS_RAISED: 'Raised',
  STATS_WARNINGS_RESOLVED: 'Resolved',
  STATS_SERVICES_TITLE: 'Services',
  STATS_SERVICE: 'Service',
  STATS_SERVICES_ACCEPTED: 'Accepted',
  STATS_SERVICES_REJECTED: 'Rejected',
  STATS_SERVICES_FAILED: 'Failed',
  STATS_SERVICES_SPEND: 'Spend',
  STATS_SERVICES_SPEND_BY_SERVICE: 'Spend by service',
  STATS_SERVICES_BY_SERVICE: 'Usage by service',
  STATS_SERVICES_NO_SPEND: 'No spend in this period',
  STATS_REVIEWERS_CHART_TITLE: 'Decisions by reviewer',
  STATS_REVIEWERS_NO_DECISIONS: 'No reviewer decisions in this period',
  STATS_GEO_TITLE: 'Geography',
  STATS_GEO_DOCUMENT: 'Document',
  STATS_GEO_PHONE: 'Phone',
  STATS_GEO_IP: 'IP',
  STATS_GEO_COUNTRY: 'Country',
  STATS_GEO_UNKNOWN: 'No country: {{value}}',
  STATS_GEO_DOCUMENT_HINT: 'Counts every document checked, rejected ones included',
  STATS_REVIEWERS_TITLE: 'Reviewers',
  STATS_REVIEWER: 'Reviewer',
  STATS_REVIEWER_ASSIGNED: 'Assigned',
  STATS_REVIEWER_DECISIONS: 'Decisions',
  STATS_SHOW_ALL: 'Show all ({{total}})',
  STATS_SHOW_LESS: 'Show less',
  STATS_BADGE_FAST: 'fast',
  STATS_BADGE_SLOW: 'slow',
  STATS_BADGE_SHARE: 'Approval share {{share}}',
  STATS_MEDIAN: 'Median',
  STATS_P90: '90th percentile',
  STATS_TIME_TO_DECISION: 'Time to decision',
  STATS_TIME_TO_DECISION_SUMMARY_one: 'Median {{median}}, 90th percentile {{p90}} · {{total}} decision timed',
  STATS_TIME_TO_DECISION_SUMMARY_other:
    'Median {{median}}, 90th percentile {{p90}} · {{total}} decisions timed',
};

export default locale;
